import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { useDownloadExcelTemplate } from "@/features/accounts/csv-excel/hooks/use-download-template";


interface Props {
  csvExcelAccountId: string;
  onCloseModal: () => void;
  onCompleteModal: () => void;
}

export const DownloadExcelTemplateModal = ({ csvExcelAccountId, onCloseModal, onCompleteModal }: Props) => {
  const { setOpenHomeModal } = useModalContext();
  const { downloadExcelTemplate } = useDownloadExcelTemplate({ onCompleteModal });

  return (
    <BasePageModal
      handleClose={onCloseModal}
      title="Excelテンプレートのダウンロード"
      bottomChildren={
        <>
        <BaseRoundButton
          buttonText="キャンセル"
          className="btn-cancel"
          onClick={async () => {
            setOpenHomeModal("FirstUploadExcel")
          }}
        />
        <BaseRoundButton
          buttonText="ダウンロード"
          onClick={async () => {
            const res = await downloadExcelTemplate(csvExcelAccountId);
            if (res) {
              setOpenHomeModal("FirstUploadExcel")
            }
          }}
        />
        </>
      }
      disableOverlayClose={true}
    >
      <h2>Excel明細帳のテンプレートファイルをダウンロードしますか？</h2>
    </BasePageModal>
  );
};
